<template>
  <div class="underLogoPhrase">

    <h2 class="font-weight-bold mb-4 centers">Qui sommes-nous</h2>
      </div>

      <div class="container" style="margin-top: 20px;">
        <h4 class="titleblue titlecontainershop" style="text-align: left;">
          <b>Présentation :</b>
        </h4>

        <p v-html="formattedPresentation"></p>
        <br><br>
   <div class="row">
                            <div class="col-lg-4" v-if="informations.img1">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + informations.img1"
                                :alt="'illustration d un service refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>

                            <div class="col-lg-4" v-if="informations.img2">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + informations.img2"
                                :alt="'illustration d un service de refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>

                            <div class="col-lg-4" v-if="informations.img3">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + informations.img3"
                                :alt="'illustration d un service refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>
                    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
 informations: {}
    };
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          console.log(data);
          
          this.informations = data[0];
        }
      })
      .catch(error => {
        console.error('Erreur getInformations:', error.message);
      });
  },

  computed: {
    formattedPresentation() {
      if (this.informations && this.informations.presentation) {
        let decoded = this.decodeHtml(this.informations.presentation);

        decoded = decoded
          .replace(/<br\s*\/?>/gi, '')
          .replace(/&nbsp;/gi, ' ')
          .trim();

        // Gestion iframe vidéo
        const iframeMatch = decoded.match(/src="([^"]+)"[^>]*title="([^"]*)"/i);

        if (iframeMatch) {
          const src = iframeMatch[1];
          const title = iframeMatch[2] || 'Vidéo';

          return `
            <div class="ratio ratio-16x9">
              <iframe src="${src}" title="${title}" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
              </iframe>
            </div>
          `;
        }

        return decoded.replace(/\r?\n/g, '<br>');
      }

      return '';
    }
  },

  methods: {
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }
};
</script>

<style src="../assets/css/besoins.css"></style>
